module.exports = __webpack_public_path__ + "img/cpxq2.bd4fef82.png";